import { clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

/**
 * Las utilidades PROPIAS del proyecto hay que declarárselas a tailwind-merge o
 * quedan fuera de su resolución de conflictos.
 *
 * `sheen-1/2/chrome/control` y `canvas-wash` (definidas en `@layer utilities`
 * de src/index.css) escriben todas `background-image`, igual que `bg-none` y
 * `bg-gradient-to-*`. Sin registrarlas, `cn("sheen-1", "sheen-2")` devolvía las
 * DOS y ganaba la que el CSS emitiera después, no la última del string — que es
 * exactamente el bug que este módulo existe para evitar (ver abajo).
 *
 * Van dentro del grupo `bg-image` que ya trae tailwind-merge, así que también
 * se resuelven contra `bg-none` — el `active:bg-none` del botón, que apaga el
 * degradado al pulsar.
 *
 * El nombre sin prefijo `bg-` es deliberado y NO se puede cambiar: como clave
 * de `backgroundImage` en tailwind.config serían `bg-sheen-1`, y twMerge las
 * metería en el grupo de background-COLOR, borrando el `bg-primary-strong` de
 * al lado (botón primario blanco con texto blanco).
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "bg-image": ["sheen-1", "sheen-2", "sheen-chrome", "sheen-control", "canvas-wash"],
    },
  },
});

/**
 * Une clases y RESUELVE conflictos de Tailwind: la última gana.
 *
 * Sin `twMerge` esto era clsx puro y un `className` pasado a un primitivo NO
 * podía sobrescribir su clase base: ambas quedaban en el elemento y decidía el
 * orden del CSS emitido, no el orden en el string. Y ese orden NO es la escala
 * del token — Tailwind 3 JIT emite las utilidades de un mismo grupo ordenadas
 * ALFABÉTICAMENTE por nombre de clase (verificado con `npx tailwindcss` sobre
 * este config y sobre uno vacío):
 *
 *     .rounded-2xl … .rounded-full … .rounded-lg … .rounded-md … .rounded-xl
 *     .text-2xl … .text-sm … .text-success … .text-text-muted … .text-text-primary
 *
 * De ahí que `<Button className="rounded-full">` quedara redondeado en `md` y
 * `<Card className="text-success">` saliera blanca. Mover `borderRadius` de
 * `theme.extend` a `theme` en tailwind.config.js NO cambia ese orden (probado):
 * el arreglo real es este.
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
